export const GRAPHQL_VARIABLES = {
  page: 1,
  perPage: 10,
  filter: {}
};

export const QUERY = `
  query billsPagination ($page: Int, $perPage: Int, $filter: AutoFilledFilterFindManybillsInput, $sort: SortFindManybillsInput) {
    billsPagination (page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
        count
        items {
            companyId
            invoiceId
            vendorId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            _id
            updatedAt
            createdAt
        }
        pageInfo {
            currentPage
            perPage
            pageCount
            itemCount
            hasNextPage
            hasPreviousPage
        }
    }
  }
`;
